// @core/api/endpoints/authn/invalidate_all_tokens.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InvalidateTokensRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Invalidate all user tokens (logout from all devices)
 * Revokes all active access and refresh tokens for the current user across all devices. Use this for security purposes such as suspected account compromise.
 */
export async function InvalidateAllTokens(
  data: InvalidateTokensRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/tokens/invalidate/all`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
